import { AnimatePresence } from "framer-motion";
import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import CursorFollower from "./components/CursorFollower";
import ScrollToTop from "./components/ScrollToTop";
import AppFooter from "./components/shared/AppFooter";
import AppHeader from "./components/shared/AppHeader";
import "./css/App.css";
import UseScrollToTop from "./hooks/useScrollToTop";
import { SingleProjectProvider } from "./context/SingleProjectContext.jsx";
import { SpeedInsights } from "@vercel/speed-insights/react";

const Contact = lazy(() => import("./pages/Contact.jsx"));
const Home = lazy(() => import("./pages/Home"));
const Projects = lazy(() => import("./pages/Projects"));
const ProjectSingle = lazy(() => import("./pages/ProjectSingle.jsx"));

function App() {
  useEffect(() => {
    document.documentElement.classList.remove("dark", "light");
    localStorage.removeItem("theme");
  }, []);

  return (
    <SingleProjectProvider>
      <SpeedInsights />
      <AnimatePresence>
        <div className="min-h-screen bg-white text-black transition duration-300">
          <CursorFollower />
          <Router>
            <ScrollToTop />
            <AppHeader />
            <Suspense fallback={""}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="projects" element={<Projects />} />
                <Route
                  path="projects/single-project"
                  element={<ProjectSingle />}
                />
                <Route path="contact" element={<Contact />} />
              </Routes>
            </Suspense>
            <AppFooter />
          </Router>
          <UseScrollToTop />
        </div>
      </AnimatePresence>
    </SingleProjectProvider>
  );
}

export default App;
